import { render, staticRenderFns } from "./setting-monlthy-biling.vue?vue&type=template&id=81c2ad8c&"
import script from "./setting-monlthy-biling.vue?vue&type=script&lang=js&"
export * from "./setting-monlthy-biling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports